import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/input/Button';
import TextInput from '../../components/input/TextInput';
import Spacer from '../../components/Spacer';
import { Heading } from '../../components/typography/Typography';

const Container = styled.div`
  width: 90vw;
  @media (min-width: 1200px) {
    width: 341px;
  }
`;

function MerchantSignup() {
  const [formState, setFormState] = useState({
    accountName: '',
    name: '',
    email: '',
    password: '',
  });

  const handleKey = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // login();
    }
  };

  return (
    <Container>
      <Heading>Merchant sign up</Heading>
      <TextInput
        label='ACCOUNT NAME'
        fullWidth
        value={formState.accountName}
        onKeyDown={(e) => handleKey(e)}
        validate='text'
        onChange={(text) => setFormState({ ...formState, accountName: text })}
      />
      <Spacer vertical spacing={2} />
      <TextInput
        label='NAME'
        fullWidth
        value={formState.name}
        validate='text'
        onKeyDown={(e) => handleKey(e)}
        onChange={(text) => setFormState({ ...formState, name: text })}
      />
      <Spacer vertical spacing={2} />
      <TextInput
        label='EMAIL'
        fullWidth
        value={formState.email}
        validate='email'
        onKeyDown={(e) => handleKey(e)}
        onChange={(text) => setFormState({ ...formState, email: text })}
      />
      <Spacer vertical spacing={2} />
      <TextInput
        label='PASSWORD'
        fullWidth
        type={'password'}
        value={formState.password}
        validate='password'
        onKeyDown={(e) => handleKey(e)}
        onChange={(text) => setFormState({ ...formState, password: text })}
      />
      <Spacer vertical spacing={3} />
      <Button color='white'>Create Account</Button>
    </Container>
  );
}

export default MerchantSignup;
